import { BankAccountDataModel, BankAccountRepository, SepaModel } from '@/Contract/domain'
import { BankAccountChangeForm, BankAccountConfirmationForm } from '@/Contract/ui/hooks'
import { LogaltyModel, LogaltyResponseStatus } from '@/Logalty/domain'
import { HttpModel } from '@/Shared/domain'

interface IAccountContract {
  getBankAccountData: (
    merchantTargetId: number,
  ) => Promise<HttpModel<BankAccountDataModel>>
  getSepaDocument: (data: BankAccountChangeForm) => Promise<HttpModel<SepaModel>>
  acceptSepaDocument: (
    data: BankAccountConfirmationForm,
  ) => Promise<HttpModel<LogaltyModel>>
  getSignStatus: (
    data: BankAccountConfirmationForm,
  ) => Promise<HttpModel<LogaltyResponseStatus>>
}

export const AccountContract = (
  accountRepository: BankAccountRepository,
): IAccountContract => ({
  getBankAccountData: async (
    merchantTargetId: number,
  ): Promise<HttpModel<BankAccountDataModel>> =>
    await accountRepository.GetBankAccountData(merchantTargetId),
  getSepaDocument: async (data: BankAccountChangeForm): Promise<HttpModel<SepaModel>> =>
    await accountRepository.GetSepaDocument(data),
  acceptSepaDocument: async (
    data: BankAccountConfirmationForm,
  ): Promise<HttpModel<LogaltyModel>> => await accountRepository.AcceptSepaDocument(data),
  getSignStatus: async (
    data: BankAccountConfirmationForm,
  ): Promise<HttpModel<LogaltyResponseStatus>> =>
    await accountRepository.GetSignStatus(data),
})
